<template>
  <v-sheet>
    <div class="border">
      <div class="inner-border">Current</div>
      <base-grid
        :showAdd="false"
        :showDelete="false"
        :badgeIcons="badgeIcons"
        :badgeColors="badgeColors"
        :items="incompleteCourses"
        :imageUrls="incompleteCoursesImageUrls"
        v-on:grid:badge:click="
          $store.dispatch('courses/updateCourse', {
            id: $event.id,
            touched: true
          })
          $router.push({ name: 'coursesMember', params: { id: $event.id } })
        "
        gridId="js-course-grid-current"
      />
    </div>
    <div class="border-bottom">
      <div class="inner-border">Completed</div>
      <base-grid
        :showAdd="false"
        :showDelete="false"
        :items="completedCourses"
        :imageUrls="completedCoursesImageUrls"
        v-on:grid:badge:click="
          $router.push({
            name: 'coursesMember',
            params: { id: $event.id }
          })
        "
        gridId="js-course-grid-completed"
      />
    </div>
  </v-sheet>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import BaseGrid from "@/components/BaseGrid"
import User from "@/lib/user"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin],
  components: {
    BaseGrid
  },
  data: function() {
    return {
      title: "Learning Resources"
    }
  },
  computed: {
    ...mapGetters("courses", ["getCompletedCourses", "getIncompleteCourses"]),
    completedCourses() {
      return this.getCompletedCourses.filter(el => !el.hidden)
    },
    incompleteCourses() {
      return this.getIncompleteCourses.filter(el => !el.hidden)
    },
    completedCoursesImageUrls() {
      return this.completedCourses.map(el => el.badge_url)
    },
    incompleteCoursesImageUrls() {
      return this.incompleteCourses.map(el => el.badge_url)
    },
    badgeIcons() {
      return this.incompleteCourses.map(el =>
        el.touched ? undefined : "mdi-new-box"
      )
    },
    badgeColors() {
      return Array(this.incompleteCourses.length).fill("green")
    }
  },
  created() {
    this.$store.dispatch("courses/loadMemberCourses", {})

    // this.$store.dispatch("courses/loadCourses", {
    //   showTemplates: false,
    //   showHidden: false
    // })
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/course-grid";
</style>
